$(function() {
    // $('.parallax-window').parallax({imageSrc: '/path/to/image.jpg'});
});
